import { Component } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { startWith } from 'rxjs/operators';
import { TranslateService } from '@ngx-translate/core';
import { TermsConditionsDialogComponent } from 'app/main/authentication/signup/terms-conditions-dialog/terms-conditions-dialog.component';

@Component({
    selector: 'footer',
    templateUrl: './footer.component.html',
    styleUrls: ['./footer.component.scss']
})
export class FooterComponent {
    date: Date;
    systemLang: string;

    constructor(
        private _translateService: TranslateService,
        private _dialog: MatDialog,
    ) {
        this.date = new Date();
        _translateService.onLangChange.pipe(startWith('')).subscribe(() => {
            if (this._translateService.currentLang === 'es_AR') {
                this.systemLang = 'es_AR';
            } else if (this._translateService.currentLang === 'en_US') {
                this.systemLang = 'en';
            } else {
                this.systemLang = this._translateService.currentLang || 'en';
            }
        });
    }

    openTermsConditions(event?: Event): void {
        event?.preventDefault();
        event?.stopPropagation();
        this._dialog.open(TermsConditionsDialogComponent, {
            panelClass: 'terms-conditions-dialog',
            autoFocus: false,
            restoreFocus: true,
            disableClose: true,
            maxWidth: '100vw',
            data: { lang: this.systemLang || 'en' },
        });
    }
}
